import React, { useContext } from "react";
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  TextField,
  DialogActions,
  Divider,
  Typography,
} from "@material-ui/core";
import ButtonDownload from "../ButtonDownload";
import { HourlyDataContext } from "../../Contexts/HourlyDataContext";

const View = (props) => {
  const { truckId, itemData, week, day, itemId, ...otherProps } = props;
  const { createHourlyModel } = useContext(HourlyDataContext);

  const hourlyModel = createHourlyModel({ week, day });

  const displayColumns = [
    "startTimeString",
    "endTimeString",
    "hourlyRate",
    "totalHours",
    "totalCharge",
    "driverComments",
    "adminComments",
  ];

  const calcItemData = {
    ...itemData,
    totalCharge: hourlyModel.totalCharge.calculateValue(itemData),
    totalHours: hourlyModel.totalHours.calculateValue(itemData),
  };

  return (
    <Dialog {...otherProps} fullWidth maxWidth="sm">
      <DialogTitle>View Item</DialogTitle>
      <Divider />
      <DialogContent>
        <Grid
          container
          direction="row"
          justify="flex-start"
          alignItems="center"
          spacing={1}
        >
          {displayColumns.map((col) => (
            <React.Fragment key={col}>
              <Grid item xs={4}>
                <Typography>{hourlyModel[col].displayName}:</Typography>
              </Grid>
              <Grid item xs={8}>
                <TextField
                  fullWidth
                  value={hourlyModel[col].displayValue(calcItemData)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  disabled
                />
              </Grid>
            </React.Fragment>
          ))}
        </Grid>
      </DialogContent>
      <Divider />
      <DialogActions>
        <ButtonDownload variant="contained" color="primary" itemId={itemId} />
      </DialogActions>
    </Dialog>
  );
};

export default View;
